import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';

export default function Footer() {
    if (window.location !== window.parent.location) {
        return <></>;
    }
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                gap: '16px',
                padding: '20px',
                borderTopWidth: '1px',
                borderTopStyle: 'solid',
                borderTopColor: 'rgba(255,255,255,0.12)',
                flexWrap: 'wrap',
                backgroundColor: 'var(--wpa-dark-blue)',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: '220px',
                }}
            >
                <a href='https://www.kap7.com.au'>
                    <Image
                        className="mx-2"
                        src={`${process.env.PUBLIC_URL}/kap7_logo.png`}
                        height={50}
                    />
                </a>
                <a href="https://www.goldbarsports.tech/"><small style={{ color: 'var(--wpa-muted)' }}>In partnership with KAP7</small></a>
            </div>

            <nav
                aria-label="Footer navigation"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '18px',
                    flexGrow: 1,
                    flexWrap: 'wrap',
                    paddingBottom: '6px',
                }}
            >
                <Link to="/myorganizations" style={{ textDecoration: 'none', color: 'var(--wpa-yellow)' }}>
                    <small>My Teams</small>
                </Link>
                <Link to="/myevents" style={{ textDecoration: 'none', color: 'var(--wpa-yellow)' }}>
                    <small>My Tournaments</small>
                </Link>
                <Link to="/myaccount" style={{ textDecoration: 'none', color: 'var(--wpa-yellow)' }}>
                    <small>Account</small>
                </Link>
            </nav>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    minWidth: '220px',
                }}
            >
                <a href="https://www.goldbarsports.tech/"><small style={{ color: 'var(--wpa-muted)' }}>Made by Gold Bar Sports Tech, LLC</small></a>
                <a href="mailto:support@cbwaterpolo.com"><small style={{ color: 'var(--wpa-muted)' }}>Contact</small></a>
                <a href={`${process.env.PUBLIC_URL}/WPA_TOS_10_30_24.pdf`}><small style={{ color: 'var(--wpa-muted)' }}>Terms & Conditions</small></a>
            </div>
        </div>        
    );
}
